// components/Bild.jsx
//
// Ein Bild, dessen Quelle fehlen darf.
//
// Zwei Fallen, die dieses Stueck abnimmt:
//
//  1. `<img src="">` -- ein leerer Pfad ist kein "kein Bild": der Browser
//     fordert damit die ganze Seite noch einmal an, und React meldet es als
//     Fehler in der Konsole. Ohne Quelle wird hier gar nichts gerendert.
//
//  2. Ein kaputter Pfad wird ueber onError ausgeblendet. Damit das Bild beim
//     NAECHSTEN, gueltigen Pfad wieder erscheint, braucht es `key={src}` --
//     sonst bleibt das einmal gesetzte display:none am selben Element haengen
//     und die Kachel bleibt leer, obwohl das Bild da waere.

import React from 'react';

export default function Bild({ src, alt = '', className, ...rest }) {
  if (!src) return null;
  return (
    <img
      key={src}
      className={className}
      src={src}
      alt={alt}
      onError={(e) => { e.currentTarget.style.display = 'none'; }}
      {...rest}
    />
  );
}
